import { TMockExamSessionSubject } from "@/infrastructure/adapters/mock-exam";

const MOCK_EXAM_CACHE_KEY = "mock-exam-quiz-state";

export type TMockExamCacheState = {
  mockExamId: number;
  attemptId: number;
  finishedAt: string;
  subjects: TMockExamSessionSubject[];
  examDurationSeconds: number;
  answers: Record<number, string>;
  currentSubjectIndex: number;
};

const isMockExamCacheState = (value: unknown): value is TMockExamCacheState => {
  if (typeof value !== "object" || value === null) return false;

  const obj = value as Record<string, unknown>;

  const attemptId = Number(obj.attemptId);
  const mockExamId = Number(obj.mockExamId);
  return (
    typeof attemptId === "number" &&
    attemptId > 0 &&
    typeof mockExamId === "number" &&
    mockExamId > 0 &&
    typeof obj.finishedAt === "string" &&
    Array.isArray(obj.subjects) &&
    obj.subjects.length > 0 &&
    typeof obj.examDurationSeconds === "number" &&
    typeof obj.answers === "object" &&
    obj.answers !== null &&
    typeof obj.currentSubjectIndex === "number"
  );
};

export const loadMockExamCache = (): TMockExamCacheState | null => {
  try {
    const raw = sessionStorage.getItem(MOCK_EXAM_CACHE_KEY);
    if (!raw) return null;

    const parsed: unknown = JSON.parse(raw);
    if (!isMockExamCacheState(parsed)) return null;

    return parsed;
  } catch {
    return null;
  }
};

export const saveMockExamCache = (state: TMockExamCacheState): void => {
  try {
    sessionStorage.setItem(MOCK_EXAM_CACHE_KEY, JSON.stringify(state));
  } catch {
    // sessionStorage full or unavailable — silently ignore
  }
};

export const clearMockExamCache = (): void => {
  sessionStorage.removeItem(MOCK_EXAM_CACHE_KEY);
};
